import { render, staticRenderFns } from "./registerStep3.vue?vue&type=template&id=2fc24d6f&scoped=true"
import script from "./registerStep3.vue?vue&type=script&lang=js"
export * from "./registerStep3.vue?vue&type=script&lang=js"
import style0 from "./registerStep3.vue?vue&type=style&index=0&id=2fc24d6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc24d6f",
  null
  
)

export default component.exports